import React from 'react';
import {
  DataValueColorNavy,
  DataHeading,
} from '../../../commonStyles';
import {
  GrantsCountMobile,
  GrantText,
  GrantCount,
  GrantsHeading,
  BottomSpan,
} from './styles';
import ArrowImage from '../../../../assets/icons/arrow-teal-r.svg';
import Preloader from '../../../Preloader/Preloader';
import withRouter from 'react-router-dom/withRouter';
import {
  ContentMessage,
  Types,
} from '../../../ContentMessages';
import { recordError } from '../../../../utils/commonUtil';
import PropTypes from 'prop-types';

function goToPage(props, tab, tabName) {
  try {
    props.handleLinkAnalytics('grantOverviewTopLink', '', tabName);
    props.history.push({
      pathname: `/grants/activity`,
      state: { grantTab: tab },
    });
  } catch (error) {
    recordError(error);
  }
}

const SummaryMobile = (props) => {
  const { accData, isLoading, grantsCount } = props;
  return (
    <>
      <GrantsHeading>
        <ContentMessage
          page='Grants Overview'
          type={Types.PAGE_TITLE_DESCRIPTION}
          property='field_page_title'
          defaultMessage={<Preloader styling='btnLoader' />}
        ></ContentMessage>
      </GrantsHeading>
      <DataValueColorNavy isBreak className='mt-10 name-handle'>
        {accData.accountName} - {accData.accountId}
      </DataValueColorNavy>
      <DataHeading />
      {isLoading ? (
        <Preloader />
      ) : (
        <GrantsCountMobile
          className='grant-dashboard'
          data-test='grantsMobileCount'
        >
          {grantsCount.grantAgreement && grantsCount.grantAgreement !== 0 ? (
            <div>
              <GrantCount>
                {grantsCount.grantAgreement !== null ? (
                  grantsCount.grantAgreement
                ) : (
                  <span>&mdash;</span>
                )}
              </GrantCount>
              <BottomSpan>
                <GrantText
                  weight='normal'
                  onClick={() => goToPage(props, '3', 'Grant Agreements')}
                  data-test='grantsDashboardAgreementMobileClick'
                  id='anrGrantAgreementsMobile'
                >
                  Grant Agreements
                </GrantText>
              </BottomSpan>
              <img src={ArrowImage} alt='arrow_image' />
            </div>
          ) : null}
          {grantsCount.activeSchedules && grantsCount.activeSchedules !== 0 ? (
            <div>
              <GrantCount>
                {grantsCount.activeSchedules !== null ? (
                  grantsCount.activeSchedules
                ) : (
                  <span>&mdash;</span>
                )}
              </GrantCount>
              <BottomSpan>
                <GrantText
                  weight='normal'
                  onClick={() => goToPage(props, '2', 'Active Schedules')}
                  data-test='grantsDashboardSchedulesMobileClick'
                  id='anrActiveSchedules'
                >
                  Active Schedules
                </GrantText>
              </BottomSpan>
              <img src={ArrowImage} alt='arrow_image' />
            </div>
          ) : null}
          {grantsCount.pendingGrant && grantsCount.pendingGrant !== 0 ? (
            <div>
              <GrantCount>
                {grantsCount.pendingGrant !== null ? (
                  grantsCount.pendingGrant
                ) : (
                  <span>&mdash;</span>
                )}
              </GrantCount>
              <BottomSpan>
                <GrantText
                  weight='normal'
                  onClick={() => goToPage(props, '1', 'Pending Grants')}
                  data-test='grantsDashboardPendingGrantsMobileClick'
                  id='anrPendingGrantsMobile'
                >
                  Pending Grants
                </GrantText>
              </BottomSpan>
              <img src={ArrowImage} alt='arrow_image' />
            </div>
          ) : null}
        </GrantsCountMobile>
      )}
    </>
  );
};

export default withRouter(SummaryMobile);

SummaryMobile.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  handleLinkAnalytics: PropTypes.func,
  grantsCount: PropTypes.shape({
    activeSchedules: PropTypes.number,
    availableBalance: PropTypes.number,
    currentBalance: PropTypes.number,
    grantAgreement: PropTypes.number,
    grantIssuedYTD: PropTypes.number,
    pendingGrant: PropTypes.number,
  }),
  accData: PropTypes.shape({
    accountId: PropTypes.string,
    accountName: PropTypes.string,
    availableBalance: PropTypes.number,
    beginBalance: PropTypes.number,
    currentBalance: PropTypes.number,
    dateChanged: PropTypes.number,
    endBalance: PropTypes.number,
    grantsAndContribution: PropTypes.number,
    grantsYTD: PropTypes.number,
    marketMovement: PropTypes.number,
    roleAccess: PropTypes.string,
    ytdPercentage: PropTypes.number,
    ytdPercentageIncrease: PropTypes.bool,
  }),
};
